import roomLib from 'modules/widgets/lib/room';
import { request } from 'lib';
import { getRoomId } from 'client/pc/lib/room';

let adminList = [];
const init = () => {
  roomLib.isAdmin = (userId) => {
    const index = adminList.findIndex((item) => {
      return item._id === userId;
    });
    return index > -1;
  };

  loadList();
};

const loadList = () => {
  request.api.get(`public/room_admin/${getRoomId()}`).then((res) => {
    adminList = res.data.list;
  });
};

const updateList = (list) => {
  adminList = list;
};

const initSocket = (socket) => {
  socket.on('room.admin_list', (msg) => {
    updateList(msg.data_d.list || []);
  });
};

export default {
  init,
  updateList,
  initSocket,
};
